import { Switch } from 'antd';

import './BaseSwitch.scss';

export const BaseSwitch = ({ value, onChange }) => {
  return <Switch checked={value} onChange={onChange} data-testid="base-switch" />;
};

export default BaseSwitch;
